/* BPO */
import { FEATURES } from '@constants/Text'
import * as opportunitiesStore from './store'

export function opportunitiesModule({ store }) {
  store.registerModule('opportunities', {
    ...opportunitiesStore,
    namespaced: true,
  })
}

export const PERMISSION = FEATURES.OPPORTUNITIES
